module.exports = __webpack_public_path__ + "media/images/gs-logo-38ff0f34.png";